module.exports = "https://deal-img.imgix.net/consumer/favicon-32x32.90b010e4.png";